import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  infoBox: {
    marginTop: '16px',
    padding: '16px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
  },
  
  infoLabel: {
    marginTop: '8px',
  },
  
  firstInfoLabel: {
    marginTop: 0,
  },
}));

export default useStyles;